module.exports = __webpack_public_path__ + "static/media/logo-tp-icap.2c9a7582.png";